import React from 'react';
import { connect } from 'react-redux';
import { Field, Checkbox } from '../../components/Common';
import { validateEmail, validatePassword } from '../../utils/validForm';

export class ProfilForm extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            email: '',
            motDePasse: '',
            autorisationEmailMaf: this.props.beneficiaire && this.props.beneficiaire.autorisationEmailMaf,
            changed: false,
            displayPassword: false,
            displayConfirmPassword: false,
            autorisationEmail: "J'accepte de recevoir des mails de rappel de la part de "+this.props.partenaireData.marqueAllianzPartners,
            error: {
                email: '',
                motDePasse: '',
                confirmPassword: ''
            }

        }
    }

    handleSubmit = (e) => {
        e.preventDefault();
        this.props.onSubmit({
            email: this.state.email,
            motDePasse: this.state.motDePasse,
            autorisationEmailMaf: this.state.autorisationEmailMaf
        });
    }

    validForm = (key, value) => {
        let obj = {}
        if (key === "email") {
            obj.email = !validateEmail(value) && ' is-invalid';
            this.setState(prevState => ({
                error: {
                    ...prevState.error,
                    ...obj
                }
            }));
        }
        if (key === "motDePasse") {
            obj.confirmPassword = value != this.state.confirmPassword ? ' is-invalid' : '';
            this.setState(prevState => ({
                error: {
                    ...prevState.error,
                    ...obj
                }
            }));
        }
        if (key === "confirmPassword") {
            obj.confirmPassword = value != this.state.motDePasse ? ' is-invalid' : '';
            this.setState(prevState => ({
                error: {
                    ...prevState.error,
                    ...obj
                }
            }));
        }
        this.setState(prevState => ({
            error: {
                ...prevState.error,
                ...obj
            }
        }));
    }
    
    validPassword = (key, value) => {
    	let obj = {};
        if (key === "motDePasse") {
            obj.motDePasse = !validatePassword(value) && ' is-invalid';
            if ( value === '' && (this.state.confirmPassword === '' || this.state.confirmPassword === undefined) ){
            	obj.motDePasse = '';
            	obj.confirmPassword = '';
            }
        }
        if (key === "confirmPassword") {
            obj.confirmPassword = !validatePassword(value) && ' is-invalid';
            if ( value === '' && (this.state.motDePasse === '' || this.state.motDePasse === undefined) ){
            	obj.motDePasse = '';
            	obj.confirmPassword = '';
            }
        }
        this.setState(prevState => ({
            error: {
                ...prevState.error,
                ...obj
            }
        }));
    }

    handleOnChange(key, e) {
        let value = e.target.value;
        if (e.target.type === "checkbox")
            value = e.target.checked;
        this.validForm(key, value);
        this.validPassword(key, value);
        if (e.target.type === "checkbox") {
            this.setState(() => ({ [key]: value, changed: !this.state.changed }));
        } else {
            this.setState(() => ({ [key]: value }));
        }
    }

    toggleDisplayPassword = (key) => {
        this.setState(prevState => ({ [key]: !prevState[key] }));
    }


    isDisableButton = () => (
        (!this.state.email || !validateEmail(this.state.email))
        && !this.state.motDePasse && !this.state.changed && !this.state.confirmPassword
    )

    render() {
        return (
            <form  onSubmit={this.handleSubmit}>
                <div className="row">
                    <div className="col-sm-5">
                        <img src='/images/profil-lg.png' alt="image profil" className="_lg" />
                        <img src='/images/profil-sm.png' alt="image profil" className=" _sm" />
                    </div>
                    <div className="col-sm-7 form-container top-form">
                        <p>
                            Vous avez ici la possibilité, si vous le souhaitez, de modifier l'adresse email de votre profil.
                             Ce nouveau email vous sera alors demandé au moment de votre prochaine connexion. <br />
                            Vous pouvez également changer le mot de passe d'accès à votre espace de recueil de mémoire.
                        </p>
                        <Field
                            label="Email*"
                            type="email"
                            _className={"form-control  " + this.state.error.email}
                            value={this.state.email}
                            onChange={this.handleOnChange.bind(this, "email")}
                            error={this.state.error.email}
                            // placeholder={this.props.beneficiaire.email}
                            errorMessage="Adresse email non valide " />
                        <div className="form-group">
	                        <div className="tooltip-toggle btn-info-tooltip" 
	                        	aria-label="Votre mot de passe doit être composé d'au moins 12 caractères avec au moins une lettre majuscule, une lettre minuscule, un chiffre, aucun caractère accentué et un caractère spécial parmi les suivants : ! @ # $ % ^ & *" 
	                             tabIndex="0"
	                           >
	                        </div>
                            <Field
                                label="Mot de passe*"
                                type={this.state.displayPassword ? 'text' : 'password'}
                                _className={"form-control  " + this.state.error.motDePasse}
                                value={this.state.motDePasse}
                                onChange={this.handleOnChange.bind(this, "motDePasse")}
                                error={this.state.error.motDePasse}
                            //placeholder="*************" 
                            />
                            <div className={this.state.displayPassword ? 'icon hidePwd' : 'icon showPwd'} onClick={() => this.toggleDisplayPassword('displayPassword')} ></div>
                        </div>
                        <div className="form-group">
	                        <Field
	                            type={this.state.displayConfirmPassword ? 'text' : 'password'}
	                            label="Confirmation du mot de passe *"
	                            _className={"form-control  " + this.state.error.confirmPassword}
	                            error={this.state.error.confirmPassword}
	                            autoFocus
	                            value={this.state.confirmPassword}
	                            onChange={this.handleOnChange.bind(this, 'confirmPassword')}
	                            errorMessage=" "
	                        />
	                        <div className={this.state.displayConfirmPassword ? 'icon hidePwd' : 'icon showPwd'} onClick={() => this.toggleDisplayPassword('displayConfirmPassword')} ></div>
	                    </div>
                        <div className="required-txt"> * Champs obligatoires</div>
                        <Checkbox
                            type="checkbox"
                            _id="autorisationEmailMaf"
                            label={this.state.autorisationEmail}
                            checked={this.state.autorisationEmailMaf}
                            value={this.state.autorisationEmailMaf}
                            onChange={this.handleOnChange.bind(this, "autorisationEmailMaf")}
                        />
                    </div>
                </div>

                <div className="button-container">
                    <button onClick={this.props.back} className="btn btn-outline-primary">ANNULER</button>
                    <button type="submit" className="btn btn-primary" disabled={this.isDisableButton()}>ENREGISTRER</button>
                </div>
            </form>
        )
    }
}

const mapStateToProps = state => ({
    partenaireData: state.partenaireData
})

export default connect(mapStateToProps, undefined)(ProfilForm);


// WEBPACK FOOTER //
// ./src/components/ProfilPage/ProfilForm.js